module.exports = __webpack_public_path__ + "static/media/uuc.892f8373.png";